import * as Types from '../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type ReportDataFragment = {
  __typename?: 'Report';
  id: any;
  title: string;
  content?: string | null;
  createdAt: any;
  updatedAt: any;
  enterprise: { __typename?: 'Enterprise'; id: any; name: string };
};

export type ReportsQueryVariables = Types.Exact<{
  pagination: Types.PaginationInput;
  filter?: Types.InputMaybe<Types.FilterReportsInput>;
}>;

export type ReportsQuery = {
  __typename?: 'Query';
  adminReports: {
    __typename?: 'PaginatedReportResult';
    totalCount: number;
    data: Array<{
      __typename?: 'Report';
      id: any;
      title: string;
      content?: string | null;
      createdAt: any;
      updatedAt: any;
      enterprise: { __typename?: 'Enterprise'; id: any; name: string };
    }>;
  };
};

export const ReportDataFragmentDoc = gql`
  fragment ReportData on Report {
    id
    title
    content
    createdAt
    updatedAt
    enterprise {
      id
      name
    }
  }
`;
export const ReportsDocument = gql`
  query reports($pagination: PaginationInput!, $filter: FilterReportsInput) {
    adminReports(pagination: $pagination, filter: $filter) {
      totalCount
      data {
        ...ReportData
      }
    }
  }
  ${ReportDataFragmentDoc}
`;
export type ReportsComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    ReportsQuery,
    ReportsQueryVariables
  >,
  'query'
> &
  ({ variables: ReportsQueryVariables; skip?: boolean } | { skip: boolean });

export const ReportsComponent = (props: ReportsComponentProps) => (
  <ApolloReactComponents.Query<ReportsQuery, ReportsQueryVariables>
    query={ReportsDocument}
    {...props}
  />
);

/**
 * __useReportsQuery__
 *
 * To run a query within a React component, call `useReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useReportsQuery(
  baseOptions: Apollo.QueryHookOptions<ReportsQuery, ReportsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ReportsQuery, ReportsQueryVariables>(
    ReportsDocument,
    options,
  );
}
export function useReportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReportsQuery,
    ReportsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ReportsQuery, ReportsQueryVariables>(
    ReportsDocument,
    options,
  );
}
export type ReportsQueryHookResult = ReturnType<typeof useReportsQuery>;
export type ReportsLazyQueryHookResult = ReturnType<typeof useReportsLazyQuery>;
export type ReportsQueryResult = Apollo.QueryResult<
  ReportsQuery,
  ReportsQueryVariables
>;
